import type { RefObject } from 'react';
import { useEffect, useState } from 'react';

interface UseSliderScrollOptions {
  activeOnView?: boolean;
  scrollByItem?: boolean;
}

// @todo: переписать хуки со скроллами и объединить их
export const useSliderScroll = (containerRef: RefObject<HTMLElement>, options: UseSliderScrollOptions = {}) => {
  const { activeOnView = false, scrollByItem = false } = options;
  const [viewIndex, setViewIndex] = useState(0);

  const scrollToWidth = 0.95;

  const scrollByItemWidth = (direction: 'left' | 'right') => {
    if (!containerRef.current) return;
    const firstChild = containerRef.current.children[0] as HTMLElement;
    if (firstChild) {
      const scrollAmount = firstChild.offsetWidth * scrollToWidth;
      containerRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    if (!activeOnView || !containerRef.current) return;

    const updateViewIndex = () => {
      const container = containerRef.current;
      if (!container) return;

      const childrenArr = Array.from(container.children);
      for (let i = 0; i < childrenArr.length; i++) {
        const el = childrenArr[i] as HTMLElement;
        const containerRect = container.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();

        if (elRect.left >= containerRect.left && elRect.right <= containerRect.right) {
          setViewIndex(i);
          break;
        }
      }
    };

    updateViewIndex();
    containerRef.current.addEventListener('scroll', updateViewIndex);
    return () => containerRef.current?.removeEventListener('scroll', updateViewIndex);
  }, [activeOnView, containerRef]);

  return {
    viewIndex,
    scrollByItemWidth,
    isScrollByItem: scrollByItem,
  };
};
